import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, RouterStateSnapshot, UrlTree } from '@angular/router';
import { select, Store } from '@ngrx/store';
import { Observable, of } from 'rxjs';

import * as fromStore from '@unico-people/shared/dashboard/data-access-store';
import { catchError, switchMap, tap,  distinctUntilChanged } from 'rxjs/operators';
import { getTokenStorage } from '@unico-people/shared/utils/storage';

@Injectable({
  providedIn: 'root'
})
export class DataAccessOrganizationsGuard implements CanActivate {
  constructor(private store: Store<fromStore.DashboardState>) {}

  canActivate(): Observable<boolean> {
    return this.checkStore().pipe(
      switchMap(() => of(true)),
      catchError(() => of(false))
    );
  }

  checkStore(): Observable<boolean> {
    return this.store.pipe(
      select(fromStore.getOrganizationLoaded),
      tap(loaded => {
        if (!loaded) {
          this.store.dispatch(fromStore.loadOrganization({payload: getTokenStorage()}));
        }
      }),
      distinctUntilChanged()
    );
  }

}
